import React, { useState,useEffect } from "react"; 
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer'; 
import { form1 } from "../Service/Api";
import { getHeader } from "../config";

const ContactUs = () => { 
      useEffect(() => {
    document.title = ' Conatct Us-  Anand Bhawan School, Barabanki';  
}, []); 
    const [formData, setFormData] = useState({
        name: "", 
        phone: "",
        email: "",
        subject: "",
        message: "",
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setErrors({ ...errors, [e.target.name]: "" }); // Clear the error for the field being changed
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email is not valid.";
        }
        if (!formData.phone) newErrors.phone = "Phone Number is required.";
        if (!formData.subject) newErrors.subject = "Subject is required.";
        if (!formData.message) newErrors.message = "Message is required.";
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const type = 'abc'; 
        console.log('Submitting form with type:', type); // Debugging line
        try {
            const { header } = getHeader();
            const response = await form1(formData, header, type); 
            console.log('Form submitted successfully', response);
            document.querySelector(".primary-alert").innerHTML = "<p>Your Form Submitted Successfully.</p>";
            setFormData({
                name: "", 
                phone: "",
                email: "",
                subject: "",
                message: "",
            });
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };

    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>ContactUs</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                        <div className="col-12">
                            <div className="formbox">
                            <div class="formboxleft">
	<h5>Get In Touch</h5>
	<div class="addressdesc">
		<div class="addressimg"> <i class="bi bi-geo-alt-fill"></i></div>
		<Link to="https://maps.app.goo.gl/zKHJ4hLBHB7EkBuy5" target="_blank">Anand Bhawan School Dewa Road, <br/> Barabanki  Uttar Pradesh — 225001</Link>
	</div>
	<div class="addressdesc">
		<div class="addressimg"><i class="bi bi-envelope-fill"></i></div>
		<Link to="mailto:office@anandbhawanschool.com">office@anandbhawanschool.com </Link> <br/>
		<Link to="mailto:principal@anandbhawanschool.com">principal@anandbhawanschool.com</Link>
	</div>
		<div class="addressdesc">
			<div class="addressimg"><i class="bi bi-telephone-fill"></i></div>
			<Link to="tel:+918127942085">8127942085 , </Link>
			<Link to="tel:05248-222580">05248-222580</Link>
		</div>
</div>
                                <div className="formboxright"> 
                                    <form onSubmit={handleSubmit}>
                                        <div className="formdiv">
                                            <div className="form-group">
                                                <label>Name<span>*</span></label>
                                                <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange}/>
                                                {errors.name && <div className="error">{errors.name}</div>}
                                            </div>
                                            <div className="form-group">
                                                <label>Email<span>*</span></label>
                                                <input type="text" name="email" className="form-control" value={formData.email} onChange={handleChange}/>
                                                {errors.email && <div className="error">{errors.email}</div>}
                                            </div>
                                            <div className="form-group">
                                                <label>Phone No.<span>*</span></label>
                                                <input type="text" name="phone" className="form-control" value={formData.phone} onChange={handleChange}/>
                                                {errors.phone && <div className="error">{errors.phone}</div>}
                                            </div>
                                            <div className="form-group">
                                                <label>Subject<span>*</span></label>
                                                <input type="text" name="subject" className="form-control" value={formData.subject} onChange={handleChange}/>
                                                {errors.subject && <div className="error">{errors.subject}</div>}
                                            </div>
                                            <div className="form-group textarea">
                                                <label>Your Message<span>*</span></label>
                                                <textarea name="message" className="form-control" value={formData.message} onChange={handleChange}></textarea>
                                                {errors.message && <div className="error">{errors.message}</div>}
                                            </div>
                                        </div>
                                        <input type="submit" value="Submit"/>
                                        <div className="row"> 
                                            <div className="col-lg-12 col-md-12">
                                                <div className='primary-alert'></div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-12">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.0080787859347!2d81.18360527606677!3d26.93495835913298!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39996067854f0e29%3A0xc48dda92a3ea93fd!2sAnand%20Bhawan%20School!5e0!3m2!1sen!2sin!4v1737028331328!5m2!1sen!2sin" width="100%" height="300" style={{border:"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default ContactUs;
